import { gql } from '@apollo/client';
import { Schedule, Task } from '@lgg/isomorphic/types/__generated__/graphql';
import { TaskOrAppointmentItemData } from 'src/components/pages/dashboard/components/cards/shared/task-or-appointment-list';

export const CONTACT_LABEL_PREVIEW_FIELDS = gql`
  fragment ContactLabelPreviewFields on Contact {
    id
    label
    stage {
      slug
      name
    }
    status {
      name
    }
    isBlocked
    interest
    primaryEmail
    primaryPhone {
      national
      e164
      regionCode
    }
    secondaryPhone {
      national
      e164
      regionCode
    }
    lastContactInteraction {
      id
      occurredAt
    }
    tags {
      id
      name
    }
  }
`;

export const mapTaskOrAppointmentEdgesToListItemData = (
  nodes: Array<Task | Schedule>,
  dateField: string,
  userField: string,
  priorityRenderer?: (node: Schedule) => React.ReactNode,
  type: 'task' | 'appointment' = 'task',
): TaskOrAppointmentItemData[] => {
  return nodes.map((node) => ({
    id: node.id,
    title: node.title,
    date: node[dateField],
    contact: node.contact,
    assignedTo: node[userField]
      ? {
          id: String(node[userField].id),
          fullName: node[userField].fullName,
        }
      : undefined,
    ...(priorityRenderer && 'startAt' in node && { priority: priorityRenderer(node) }),
    ...(type === 'appointment'
      ? { type: 'appointment', rawNode: node as Schedule }
      : { type: 'task', rawNode: node as Task }),
  }));
};
